import Vue from 'vue'
import AwesomeMask from 'awesome-mask'

Vue.directive('mask', AwesomeMask);


// WEBPACK FOOTER //
// ./src/directive/mask.js